<template lang="pug">
div
  app-modal-cancelar-retificacao(
    v-if="showModalRetificacao",
    :idProcesso='idProcesso',
    :numeroProcesso='numeroProcesso',
    :setor='setor'
    @closeModal="closeRetificacao"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  modal-suspensao-processo(
    v-if="showModalSuspensaoProcesso",
    @closeModal="showModalSuspensaoProcesso = false",
    @refresh='refresh',
    :idProcesso="idProcesso",
    :numeroProcesso="numeroProcesso",
    :caixaSuspensao="false",
    :setor="setor",
    :sIndireta="sIndireta"
  )
  app-modal-analise-conjunta(
    v-if="showModalDespacho",
    :idsProcessos="idsProcessosValidacao",
    :showModal="showModalDespacho"
    :analiseSemDespacho="analiseSemDespacho"
    titulo='Modelos de Despacho Dinâmico',
    :tiposModelo="[4]"
    @closeModal="closeModalDespacho"
    @cancelModal="closeModalDespacho"
    @confirm="confirmarModelo"
    @filtro="closeModalDespacho"
    @cancelaTramitacao="cancelaTramitacao"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
  app-listagem(
    v-if="exibirListagem"
    :has-refresh-button="true",
    :showValidacaoColetiva="isPa && isDeaf"
    :hasMultipleCheckbox="isPa && isDeaf",
    :idsDisabledCheckbox="processosCheckboxDisabled"
    :processosSelecionados="processosColetivosSelecionados"
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :textoButtonAssinatura="textoButtonAssinatura"
    @assinarTitulos="validarProcessosColetivos"
    :has-expansivel="false",
    :json-headers="colunas",
    @selectAll="changeProcessosColetivosSelecionados"
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    :infoPrazos="showInfoVencimento() && infoPrazos"
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalAnaliseConjunta from '@/screens/analise/components/modal/AppModalAnaliseConjunta'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
import ModalSuspensaoProcesso from '@/components/ModalSuspensaoProcesso.vue'
const { filtro, showFiltroTipoMultiplo, suspensaoIndireta, montarListagem, verificarDespachoSemTexto } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalCancelarRetificacao,
    ModalSuspensaoProcesso,
    AppModalAnaliseConjunta
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('AGUARDANDO_VALIDACAO_ANALISE'),
      items: [],
      exibirListagem: true,
      totalElements: 0,
      infoPrazos: undefined,
      setoresInfoVencimento: [ 'GAC', 'CAF', 'GPA', 'GCQ', 'GEO', 'GCG', 'CGIR', 'DEAF', 'GRF', 'GAM', 'CDI', 'GIT',
        'PROTOCOLO', 'COMISSAO_ILHA', 'CAF', 'JURIDICO', 'DF1', 'DRF', 'DATGL', 'PRESIDENCIA', 'DUF', 'GRF_CAF',
        'GCG_CGIR'],
      protocolo: null,
      showModalVisualizarProcesso: false,
      showModalRetificacao: false,
      idProcesso: null,
      numeroProcesso: null,
      processosColetivosSelecionados: [],
      validarProcessosColetivos: this?.[montarListagem[this.$route.name]?.funcaoExibirModal],
      textoButtonAssinatura: montarListagem[this.$route.name].textoButtonAssinatura,
      showModalDespacho: false,
      setor: null,
      showModalSuspensaoProcesso: false,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroResponsavel?.AGUARDANDO_VALIDACAO_ANALISE || [],
        filtroResponsavel: filtro?.filtroResponsavel?.AGUARDANDO_VALIDACAO_ANALISE || [],
        filtroMunicipio: filtro?.filtroMunicipio?.AGUARDANDO_VALIDACAO_ANALISE || [],
        filtroVistoriador: filtro?.filtroVistoriador?.CAIXA_ENTRADA || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], exibir: () => this.showColuna('filtroSituacao') },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 5, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 7, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [], exibir: () => this.showColuna('filtroResponsavel') },
        { id: 8, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => this.showInfoVencimento() },
        {
          id: 9, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Validar Processo', icone: 'fa-check', codigo: 'VALIDAR', ordem: 1, show: this.showValidarProcesso, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 2, show: this.showVisualizarProcesso },
            { id: 3, nome: 'Conferir Título', icone: 'fa-check', codigo: 'CONFERIR_TITULO', ordem: 3, show: this.showConferirTitulo },
            { id: 4, nome: 'Conferir Certidão', icone: 'fa-check', codigo: 'CONFERIR_CERTIDAO', ordem: 4, show: this.showConferirCertidao },
            { id: 5, nome: 'Revisar Validação Processo', icone: 'fa-check', codigo: 'VALIDAR', ordem: 5, show: this.showRevisarValidacaoProcesso },
            { id: 6, nome: 'Cancelar Retificação', icone: 'fa-times', codigo: 'CANCELAR_RETIFICACAO', ordem: 6, show: this.showCancelarRetificacaoProcessso },
            { id: 7, nome: 'Validar Ofício', icone: 'fa-check', codigo: 'VALIDAR_OFICIO', ordem: 7, show: this.showValidarOficio, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 8, nome: 'Suspender Processo', icone: 'fa-edit', codigo: 'VIEW_PROCESSOS_SUSPENSOS', ordem: 1, show: this.showAcaoSuspender }
          ]
        }
      ],
      usuario: null,
      showFiltroTipoMultiplo,
      filtroRapido: null,
      sIndireta: false
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),
    analiseSemDespacho () {
      return verificarDespachoSemTexto(this.usuario)
    },
    isPa () {
      return process.env.ESTADO === 'pa'
    },
    isDeaf () {
      return this.usuarioLogado.perfilSelecionado.setor.codigo === 'DEAF'
    },
    processosCheckboxDisabled () {
      if (this.isPa && this.isDeaf) {
        return this.items.filter(item => item.tipoCodigo !== 'NAO_ONEROSO').map(item => item.id)
      } else {
        return []
      }
    }
  },

  methods: {
    ...mapActions({
      exportarCsvAnalise: 'processo/exportarCsvAnalise',
      suspender: 'despacho/criarDespachoSuspensaoProcesso'
    }),
    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario?.perfilSelecionado?.codigo) !== undefined
    },
    showInfoVencimento () {
      return this.setoresInfoVencimento.find(setor => setor === this.usuario?.perfilSelecionado?.setor?.codigo)
    },
    changeProcessosColetivosSelecionados (ids) {
      this.processosColetivosSelecionados = [...ids]
    },
    VALIDAR_SELECIONADOS () {
      if (this.processosColetivosSelecionados.length > 0) {
        this.idsProcessosValidacao = this.processosColetivosSelecionados.map(p => p.id)
        this.showModalDespacho = true
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.SELECIONA_MINIMO_PROCESSO_VALIDACAO
        )
      }
    },
    closeModalDespacho () {
      this.showModalDespacho = false
      this.processosColetivosSelecionados = []
      this.idsProcessosValidacao = []
      this.init()
    },
    confirmarModelo (idDocumento) {
      this.documentoSelecionado = idDocumento
      this.showModalDespacho = false
    },
    cancelaTramitacao () {
      this.showModalDespacho = false
    },
    VALIDAR_OFICIO: (_this, { item }) => {
      _this.$router.push({
        name: 'oficio',
        query: {
          idProcesso: item.id
        },
        params: {
          isEdicao: true
        }
      })
    },
    VALIDAR: (_this, { item }) => {
      _this.$router.push({
        name: 'analise/validar',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'VALIDACAO'
        }
      })
    },
    async CONFERIR_TITULO (_this, { item }) {
      this.$router.push({
        name: 'conferencia-titulo-certidao',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          numeroProcesso: item.numeroProcesso
        }
      })
    },
    async CONFERIR_CERTIDAO (_this, { item }) {
      this.$router.push({
        name: 'conferencia-certidao',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          numeroProcesso: item.numeroProcesso
        }
      })
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    CANCELAR_RETIFICACAO (_this, {item}) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.protocolo = item.numeroProtocolo
      this.setor = item.setor
      this.showModalRetificacao = true
    },
    atualizarFiltro (novoFiltro) {
      this.filtro = {
        ...this.filtro,
        ...novoFiltro
      }
      this.filtroRapido = novoFiltro
    },
    async exportarCsvFiltroAnalise () {
      await this.filtroComColunasExibidas()
      this.exportarCsvAnalise(this.filtro)
    },
    closeRetificacao () {
      this.showModalRetificacao = false
      this.refresh()
      this.exibirListagem = false
      setTimeout(() => {
        this.exibirListagem = true
      }, 1000)
    },
    async CONFERIR_VTN (_this, { item }) {
      this.$router.push({
        name: 'CONFERIR_VTN',
        params: {
          processo: item
        }
      })
    },
    VIEW_PROCESSOS_SUSPENSOS (_this, { item }) {
      this.idProcesso = item.id
      this.setor = item.setor
      this.numeroProcesso = item.numeroProcesso
      this.sIndireta = suspensaoIndireta(this.usuario.perfilSelecionado.nome)
      this.showModalSuspensaoProcesso = !this.showModalSuspensaoProcesso
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/AguardandoValidacaoListagem.vue